import { useEffect } from 'react'
import { useRouterState } from '@tanstack/react-router'

const BRAND = 'Platform'

export function useDocumentTitle(): void {
  const page = useRouterState({ select: (s) => s.matches.at(-1)?.staticData.title })

  useEffect(() => {
    document.title = page ? `${page} · ${BRAND}` : BRAND
  }, [page])
}
